import { IoClose } from 'react-icons/io5';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Spinner } from '@ds';
import { TripStatusChip } from '@lp/features/RoutePlanner/components/GroundTrip';
import { GroundTripStatus } from '@/api/apis/drive-service';

export type RemoveActiveGroundTripLegModalProps = {
  legId: string;
  tripNumber: string;
  tripStatus: GroundTripStatus;
  isOpen: boolean;
  isLoading: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onRemove: (legId: string) => Promise<void>;
  onClose: () => void;
};

export const RemoveActiveGroundTripLegModal = ({
  legId,
  tripNumber,
  tripStatus,
  isOpen,
  size = '2xl',
  isLoading,
  onRemove,
  onClose,
}: RemoveActiveGroundTripLegModalProps) => {
  const handleRemove = () => onRemove(legId);

  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      closeButton={<IoClose size={45} />}
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
        closeButton: 'text-black top-2.5 right-4',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            {isLoading && (
              <div className="absolute top-0 left-0 flex justify-center items-center z-50 w-full h-full bg-white bg-opacity-40">
                <Spinner size="md" />
              </div>
            )}
            <ModalHeader>
              <span className="text-hm font-secondary">Ground Trip Status: In Progress / Completed / Canceled</span>
            </ModalHeader>
            <ModalBody>
              <div className="flex flex-col gap-2.5">
                <span className="text-s-r text-base-20">
                  The ground trip associated with this leg is already In Progress, Completed, or Canceled.
                </span>
                <span className="text-s-r text-base-20">
                  Deleting this leg will not trigger any automated changes in TMDX Drive. The trip will remain in its
                  current status and may require manual follow-up in TMDX Drive.
                </span>
                <div className="flex gap-1 items-center">
                  <span className="text-hm font-secondary text-[#191C20]">#{tripNumber}</span>
                  <TripStatusChip status={tripStatus} />
                </div>
                <span className="text-s-r text-base-20">Are you sure you want to delete this leg?</span>
              </div>
            </ModalBody>
            <ModalFooter>
              <Button isDisabled={isLoading} size="md" color="default" variant="outline" onPress={handleRemove}>
                Delete Leg
              </Button>
              <Button size="md" variant="solid" onPress={handleClose}>
                Cancel
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
